export default "/images/vendor/flag-icon-css/flags/1x1/cd.svg?089aab7a533a120abe270615dfb3e096";